import React, {Fragment} from "react";
import ParticipantsModal from "../../../../../ui/modals/ParticipantsModal";
import SA_ShareDone from "../../../../../ui/sweetalert/SA_ShareDone";
import avatarImg from "../../../../../../assets/img/demo/player-avatar-1.png";
import check from "../../../../../../assets/svg/actions/icn-check-green-20px.svg";
import share from "../../../../../../assets/svg/actions/icn-share-20px.svg";
import "../../../../../../assets/sass/pages/scouting/shared-done-modal.scss";

class ShareModal extends ParticipantsModal {

    titles = {
        heading: "Share Scouting Reports",
        sub_heading: "Please search and select the participants you want to share the scouting reports",
        submit: "Share Scouting Report"
    };

    state = {
        participants: Array.from(Array(25).keys())
            .map((item, index) => ({
                key: index,
                avatar: avatarImg,
                name: 'Calvin Cooper',
                info: 'Scout | Canberry Football Club',
                selected: false,
            }))
    };

    onSubmit = () => {
        new SA_ShareDone().fire({
            onOpen: () => {
                this.closeModal();
            }
        })
    }

    activeIcon  = () => {
        return check;
    }

    inactiveIcon = () => {
        return share
    }
};

export default ShareModal;